import { z } from 'zod';
import { MODULE_KEYS } from '../permissions/catalog.js';
const ROLE_VALUES = ['assistant', 'doctor', 'admin', 'super_admin'];
const ACCESS_LEVEL_VALUES = ['none', 'view', 'manage'];
export const UpdatePermissionSchema = z.object({
    role: z.enum(ROLE_VALUES),
    // MODULE_KEYS is a ModuleKey[] (not a literal tuple), so refine instead of z.enum.
    moduleKey: z
        .string()
        .refine((k) => MODULE_KEYS.includes(k), {
        message: 'Unknown module key',
    }),
    accessLevel: z.enum(ACCESS_LEVEL_VALUES),
});
//# sourceMappingURL=permissions.js.map